import React from 'react';
import { FlameIcon } from 'lucide-react';
export function ScarcityBar() {
  return <div className="w-full rounded-2xl border border-red-200 bg-red-50 px-4 py-3.5" data-id="element-54" data-mp="2yw2vm54uxh0b">
      <p className="flex items-center justify-center gap-2 text-center text-[12px] font-extrabold uppercase leading-tight tracking-wide text-red-700 sm:text-sm" data-id="element-55" data-mp="2l4xt8va3uama">
        <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-56" data-mp="2q2g4wtfib3xz" />
        Only 7 spots left at the promotional price!
      </p>
      <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-57" data-mp="2b934difafjb2">
        <div className="h-full w-[93%] rounded-full bg-red-600" data-id="element-58" data-mp="275y47miojtpl" />
      </div>
      <p className="mt-1.5 text-center text-[11px] font-bold uppercase tracking-wide text-red-600" data-id="element-59" data-mp="e5mc70cegc3">
        93% claimed
      </p>
    </div>;
}